import { useEffect, useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { getNotifications, NotificationModel } from '../../../services/notification/NotificationService';

const pageSize = 5;

export interface NotificationData {
  data: NotificationModel[];
  page: number;
  pageSize: number;
  totalCount: number;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useNotificationList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [notifications, setNotifications] = useState<NotificationModel[]>([]);

  useEffect(() => {
    getNotificationsByPage(1);
  }, []);

  const getNotificationsByPage = async (page) => {
    try {
      setIsLoading(true);
      const notifications = await getNotifications(page, pageSize);
      const notificationsResult = notifications.data as unknown as NotificationData;
      setCurrentPage(page);
      setTotalCount(notificationsResult.totalCount);
      const notificationsTyped: NotificationModel[] = [];
      if (notificationsResult.data) {
        notificationsResult.data.forEach((notification) => {
          notificationsTyped.push(notification);
        });
      }

      setNotifications(notificationsTyped);
    } catch (error) {
      handleError(error);
    }

    setIsLoading(false);
  };

  return { notifications, isLoading, getNotificationsByPage, pageSize, currentPage, totalCount };
};

export default useNotificationList;
